import { forwardRef, useState } from 'react'

import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import { QuotationFields } from 'Components/UI/Molecules/Vehicles/SearchVehicles/DialogVehicle/Content/Tabs/Content/Quotation/Modals/Fields'
import { formNew } from 'Components/Validation/Vehicles/SearchVehicles'
import { format, isValid, parse } from 'date-fns'
import { Form, Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const formEdit = forwardRef((props, ref) => {
  const { data, onSubmit, companies, types } = props

  const [vehicles, setVehicles] = useState([])

  const isProveedorInOptions = Boolean(
    data?.proveedor &&
    Array.isArray(companies) &&
    companies.some((c) => c?.nombre === data.proveedor)
  )

  const normalizeDate = (value) => {
    if (!value) return null
    if (value instanceof Date) return isValid(value) ? value : null
    if (typeof value === 'string') {
      if (value.includes('T')) {
        const isoDay = value.slice(0, 10)
        const parsed = parse(isoDay, 'yyyy-MM-dd', new Date())
        return isValid(parsed) ? parsed : null
      }
      const isoParsed = parse(value.slice(0, 10), 'yyyy-MM-dd', new Date())
      if (isValid(isoParsed)) return isoParsed
      const esParsed = parse(value, 'dd-MM-yyyy', new Date())
      return isValid(esParsed) ? esParsed : null
    }
    return null
  }

  const formatDateForBackend = (value) => {
    if (!value) return null
    if (!(value instanceof Date) || !isValid(value)) return null
    return format(value, 'yyyy-MM-dd')
  }

  async function getVehiclesForPayment() {
    await interfaces.vehicleInterface.getAllVehicleForPayments().then((res) => {
      setVehicles(res.data)
    })
  }
  return (
    <Formik
      enableReinitialize
      initialValues={{
        proveedor: isProveedorInOptions ? data.proveedor : '',
        proveedor_manual: isProveedorInOptions ? '' : (data.proveedor ?? ''),
        fecha_factura: normalizeDate(data.fecha_factura),
        fecha_pago: normalizeDate(data.fecha_pago),
        suc_factura: data.suc_factura,
        nro_factura: data.nro_factura,
        monto_total: data.monto_total,
        observaciones: data.observaciones,
        tipo: data.tipo,
      }}
      validationSchema={formNew}
      onSubmit={(values) => {
        const payload = {
          ...values,
          proveedor: values.proveedor || values.proveedor_manual,
          fecha_factura: formatDateForBackend(values.fecha_factura),
          fecha_pago: formatDateForBackend(values.fecha_pago),
        }

        delete payload.proveedor_manual

        return onSubmit(payload)
      }}
    >
      {({ setFieldValue, isSubmitting, values }) => (
        <Form>
          <InputsWithValidate
            fields={QuotationFields(
              companies,
              types,
              vehicles,
              setFieldValue,
              values,
              getVehiclesForPayment
            )}
            spacing={2}
            setFieldValue={setFieldValue}
            isSubmitting={isSubmitting}
            strictManualDate={true}
          />

          <button style={{ display: 'none' }} type="submit" ref={ref} />
        </Form>
      )}
    </Formik>
  )
})

export default formEdit
